import dayjs from 'dayjs';

const API_DATE_FORMAT = 'YYYY-MM-DD';

// Safely formats any date-like value for the backend API.
// Returns null for null/undefined/empty inputs AND for structurally invalid dates
// (e.g. raw "Invalid Date" strings that can leak in from list editors).
export function formatDateForApi(value: unknown): string | null {
    if (value === null || value === undefined || value === '') {
        return null;
    }
    const d = dayjs(value as dayjs.ConfigType);
    return d.isValid() ? d.format(API_DATE_FORMAT) : null;
}

// The backend stores timestamps in UTC but Pydantic serializes them without a
// trailing "Z" (naive datetimes). Browsers parse such ISO strings as local time,
// so without coercion users see times that are off by their UTC offset. This
// helper parses a server timestamp string as UTC, returning a Date that
// `toLocaleString()` will then render correctly in the user's timezone.
export function parseServerTimestamp(value: string | null | undefined): Date | null {
    if (!value) return null;
    // If the string already has a timezone marker (Z or ±hh:mm), keep it as-is.
    const hasTz = /(Z|[+-]\d{2}:?\d{2})$/.test(value);
    const d = new Date(hasTz ? value : value + 'Z');
    return isNaN(d.getTime()) ? null : d;
}
